export default {
  setInitial(state) {
    state.initial = {};
    state.changed = {};
  },
  setChanged(state, payload) {
    if (typeof payload.oldValue === "object" && !Array.isArray(payload.oldValue)) {
      payload.oldValue = JSON.stringify(payload.oldValue, null, 2);
    }
    if (typeof payload.newValue === "object" && !Array.isArray(payload.newValue)) {
      payload.newValue = JSON.stringify(payload.newValue, null, 2);
    }

    delete Object.assign(payload, { ["new"]: payload.newValue }).newValue;
    delete Object.assign(payload, { ["old"]: payload.oldValue }).oldValue;
    if (payload.valid) {
      delete payload.ref;
    }
    if (payload?.func) {
      delete payload.func;
    }

    if (payload?.password) {
      payload.new = "********";
      payload.old = "********";
    }
    state.changed[payload.name] = payload;
  },
  removeChanged(state, { name }) {
    delete state.changed[name];
  },
  setData(state, payload) {
    state.data = payload;
  }
};
